<div class="content-container store" *ngIf="allServiceCount > 0; else storeWelcome">
  <section class="data-table">
    <header class="data-table__header">
      <h2 class="page-heading">
        <svg width="42" height="38" viewBox="0 0 42 38">
          <g class="fill-none" fill-rule="evenodd" stroke="#0CC5D1" stroke-width="2">
            <path stroke-linecap="square" d="M5.455 19L5.455 35.364 34.545 35.364 34.545 19M5.455 0L0 9.09c-.006 2.525 1.726 4.722 4.182 5.306 2.456.583 4.99-.6 6.122-2.856.914 1.841 2.792 3.006 4.848 3.006S19.086 13.38 20 11.54c.914 1.841 2.792 3.006 4.848 3.006s3.934-1.165 4.848-3.006c1.131 2.257 3.666 3.44 6.122 2.856 2.456-.584 4.188-2.78 4.182-5.305L34.545 0H5.455z" transform="translate(1 1)" />
            <path d="M16.364 35.364L16.364 24.455 23.636 24.455 23.636 35.364" transform="translate(1 1)" />
          </g>
        </svg>
        <ng-container i18n="@@my_services">My Services</ng-container>
      </h2><!-- data-table__heading -->
    </header><!-- end billing-header -->

    <div class="data-table__wrap">
      <header class="data-table__create-section">
        <div class="search-field">
          <div class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
              <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
                <circle cx="7" cy="7" r="7" />
                <path stroke-linecap="square" d="M13.5 12.5L18 17" />
              </g>
            </svg>
          </div>
          <input type="text" (keyup)="searchServices($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput />
        </div>
        <div class="create-download">
          <a href="javascript:void(0)" data-toggle="modal" id="add-product-btn" data-target="#add-services" class="tu-btn pink add-button" i18n="@@services.add_new_service" (click)="openAddServiceModal()">
            Add New Service
          </a>
        </div>
      </header>
      <header class="data-table__controls" style="flex-direction: unset; ">
        <select class="select-link" id="tab-links-select">
          <option>
            <ng-container i18n="@@common.all">All</ng-container> ({{ allServiceCount }})
          </option>
          <option *ngFor="let category of categories">{{ category.name | titlecase }} ({{ category.services_count }})</option>
        </select>
        <ul class="nav nav-pills" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" id="pills-design-pill" data-toggle="pill" href="javascript:void(0)" role="tab" aria-controls="pills-design-service" aria-selected="false" (click)="filterByCategory()" [ngClass]="{active: isActive(null)}">
              <ng-container i18n="@@common.all">All</ng-container> ({{ allServiceCount }})
            </a>
          </li>
          <ng-container *ngIf="categories.length > 0">
            <li class="nav-item" *ngFor="let category of categories">
              <a class="nav-link" id="pills-design-pill" data-toggle="pill" href="javascript:void(0)" role="tab" aria-controls="pills-design-service" aria-selected="false" (click)="filterByCategory(category)" [ngClass]="{active: isActive(category.id)}">
                {{ category.name | titlecase }} ({{ category.services_count }})
              </a>
            </li>
          </ng-container>
        </ul>
        <div class="data-table__btn-wrap">
          <div class="btn-row">
            <a href="javascript:;" (click)="openImportModal()" class="downloadXl" style="padding: 14px 14px !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
                <g fill="#0CC5D1" fill-rule="evenodd">
                  <path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
                  <path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
                </g>
              </svg>
              <span> Import .xls</span>
            </a>

            <a href="javascript:void(0);" class="downloadXl" (click)="exportXls()" >
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
                <g fill="#0CC5D1" fill-rule="evenodd">
                  <path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
                  <path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
                </g>
              </svg>
              <span i18n="@@common.download_xls">download .xls</span>
            </a>
          </div>
        </div>
      </header><!-- end header -->

      <!-- grid -->
      <ng-container *ngIf="services && services.length > 0; else noRecord">
        <service-grid 
          [myServices]="services" 
          [paginator]="paginator" 
          (onEditService)="onEditService()" 
          (onDelete)="onDeleteService($event)"
          (onSelect)="onSelectProduct($event)"
        >
        </service-grid>
      </ng-container>
      <!-- grid -->

      <!-- No record found -->
      <ng-template #noRecord>
        <div class="tab-content data-table__tab-content">
          <ng-container *ngIf="loading; else noRecord" i18n="@@common.loading">Loading...</ng-container>
          <ng-template #noRecord>
            <ng-container i18n="@@common.no_record_found">No record found.</ng-container>
          </ng-template>
        </div>
      </ng-template>
      <!-- No record found -->

      <!-- paginator  -->
      <ng-container *ngIf="paginator.totalItems > paginator.itemsPerPage">
        <nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)" aria-label="...">
          <ul class="pagination justify-content-center">
            <li class="page-item" [class.disabled]="p.isFirstPage()">
              <a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
                <svg width="7.5" height="13.5">
                  <path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                </svg>
              </a>
            </li>

            <li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
              <a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
                <span>{{ page.label }}</span>
              </a>
              <a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
                <span class="sr-only">(current)</span></a>
            </li>

            <li class="page-item" [class.disabled]="p.isLastPage()">
              <a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
                <svg width="7.5" height="13.5">
                  <path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                </svg>
              </a>
            </li>
          </ul>
        </nav>
      </ng-container>
      <!-- paginator  -->

    </div><!-- end data-table__wrap -->

  </section><!-- end data-table -->
</div>

<ng-template #storeWelcome>
  <store-welcome *ngIf="initialized" [type]="'service'" (onAddClick)="openAddServiceModal()"></store-welcome>
</ng-template>

<div class="selected_items_options" *ngIf="isServicesSelected">
  <button class="filters_block_btn delete_product_item text-danger" (click)="deleteServices()">
      <svg class="static" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <ng-container i18n="@@products.delete">Delete</ng-container>
  </button>
</div>